import React from "react";


const Rs = () => {

    return (
        <div className="component-box">
            <div className="inline-box">
                <img src="img/box-blue.png" alt="cpu" className="icon led-icon" />
                <span>周辺機器</span>
            </div>
            <div className="led-box row">
                <div className="col-md-7">
                    <div className="title-box"><span>4. RS-485</span></div>
                    <table className="data-table">
                        <thead>
                            <tr>
                                <th colSpan={2}>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>RS-485通信チェック</td>
                                <td>ok</td>
                            </tr>

                        </tbody>
                    </table>



                </div>
                <div className="col-md-5 smart-ai">
                    <img src="img/smartai.png" className="smartai" />
                </div>


                <div className="col-md-12">
                    <div className="box-wrapper failed-wrapper">
                        <span>RS-485の接続を確認できません。</span>
                        <div className="two-button-box">
                            <button className="retry">リトライ</button>
                            <button className="skip">スキップ</button>
                        </div>
                    </div>
                </div>

            </div>


        </div>

    );
};

export default Rs;